import * as React from 'react';
import SecondaryMenu from '../shared/SecondaryMenu';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import '../../style/UserStyleSheet.css';
import api from '../../store/api';
import { useState } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useHistory } from "react-router-dom";
import { TextField } from '@material-ui/core';
import ICustomer from './ICustomer';
import throttle from 'lodash/throttle';
import eventNames from '../../store/signalr/eventNames';
import { addTaskForEvent, removeTaskForEvent } from '../../store/signalr/tasksForEvents';

const useStyles = makeStyles((theme) => ({
    root: {
        //padding: theme.spacing(0, 0, 0, 35),
        paddingLeft: 40,
        paddingRight: 40,

    },
    heading: {
        fontSize: 36,
        fontWeight: 900,
        padding: theme.spacing(5, 0, 5, 0),
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
        backgroundColor: '#ECECEC',
        height: 30
    },
    formBtn: {
        width: '100px',
    },
    gridStyle: {
        padding: theme.spacing(5, 0, 5, 0)
    },
    table: {
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2, 0, 0, 50),
        },
    },
    searchTextBox: {
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: 0,
            top: 4
        },
        height: 44,
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '44px',
        border: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    tableRow: {
        cursor: 'pointer'
    },
    tableHeading: {
        fontWeight: 'bold',
    }
}));

const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
];

const componentTaskId = "viewCustomersWidget";

function ViewCustomersWidget(): JSX.Element {
    const classes = useStyles();
    const [customerList, setCustomerList] = useState<ICustomer[]>([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('name');
    const [selected, setSelected] = React.useState('');
    const [page, setPage] = React.useState(0);
    const [recordCount, setRecordCount] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchText, setSearchText] = React.useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const refOrder = React.useRef('asc');
    const refOrderBy = React.useRef('userCombinedName');
    const refSearchText = React.useRef('');
    const refPage = React.useRef(0);
   
    const whenRefreshCustomersDo = () => getAllCustomers(refPage.current, refSearchText.current, refOrder.current, refOrderBy.current);

    React.useEffect(() => {
        getAllCustomers(0, '', 'asc', 'name');
    }, []);

    React.useEffect(() => {
        addTaskForEvent(eventNames.refreshCustomers, componentTaskId, whenRefreshCustomersDo);
        return () => {
            removeTaskForEvent(eventNames.refreshCustomers, componentTaskId);
        }
    }, [whenRefreshCustomersDo]);
    
    React.useEffect(() => {
        refPage.current = page;
        refSearchText.current = searchText;
        refOrder.current = order;
        refOrderBy.current = orderBy;
    }, [page, searchText, order, orderBy]);
    //Get All Customers
    const getAllCustomers = React.useMemo(() =>
        throttle(async (updatePageNumber: any, searchKeyword: string, sortOrder: any, sortColumn: any): Promise<void> => {
            setLoading(true);
            const _res = await api.getCustomersWithSearch('searchstr=' + searchKeyword + '&pagenumber=' + (updatePageNumber ? updatePageNumber : page) + '&pagesize=10&sortcolumn=' + sortColumn + '&sortdirection=' + sortOrder);
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setRecordCount(_res.data.itemsCount);
                if (_res.data.itemsCount > 0 && updatePageNumber >= page) {
                    setCustomerList(_res.data.model);
                } else if (_res.data.itemsCount > 0 && (page == 0 || page == 1)) {
                    setCustomerList(_res.data.model);
                } else if (_res.data.itemsCount === 0) {
                    setCustomerList([]);
                }
            } else {
                setCustomerList([]);
            }
            setLoading(false);
        }, 200), []);

    const onEditClick = (event: any, id: any) => {
        if (id) {
            setSelected(id);
            history.push({
                pathname: '/settings/customers/edit/' + id,
            });
        }
    };

    const onAddClick = (event: any) => {
        history.push({
            pathname: '/settings/customers/add'
        });
    };

    const createSortHandler = (event: any, column: any) => {
        console.log(column);
        var order_str = (orderBy == column ? (order === 'asc' ? 'desc' : 'asc') : 'asc');
        setOrder(order_str);
        setOrderBy(column);
        getAllCustomers(page, searchText, order_str, column);
    };

    const handleChangePage = (event: any, newPage: any) => {
        const updatePage = newPage + 1;
        setPage(newPage);
        getAllCustomers(updatePage, searchText, order, orderBy);
    };

    const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        search(e.target.value);
    }

    const search = async (keyword: string): Promise<void> => {
        setPage(0);
        getAllCustomers(0, keyword, order, orderBy);
    }

    const searchByEnter = async (event: any): Promise<void> => {
        if (event.key === 'Enter') {
            await search(searchText);
        }
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>

            <div style={{ alignSelf: 'stretch', display: 'flex', }}>
                <SecondaryMenu selectedmenu='Customers' />
            </div>

            <div style={{ display: 'flex', alignSelf: 'start', width: '100%' }}>

                <Grid container style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                    <Grid item xs={6} style={{ paddingLeft: 40 }}>
                        <div className={classes.heading}>Customers</div>
                    </Grid>
                    <Grid item container xs={6} justify="flex-end" style={{ paddingRight: 25, paddingTop: 40, paddingBottom: 40 }}>
                        <div style={{display:'flex',}}>
                            <TextField
                                classes={{ root: classes.searchTextBox }}
                                InputProps={{

                                    startAdornment: < InputAdornment position="end" >
                                            <SearchIcon style={{ color: "#707070" }} />
                                    </InputAdornment>
                                }}
                                variant='outlined'
                                className="searchTxt"
                                id="standard-adornment-password"
                                type="text"
                                onKeyPress={searchByEnter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => inputChangedHandler(e)}
                            />


                            <Button className="searchBtn" style={{ marginLeft: 20 }} onClick={onAddClick} variant="contained" color="primary">Add Customer</Button>
                        </div>

                    </Grid>

                    <Grid container item xs={12} justify="flex-end">
                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={dense ? 'small' : 'medium'}
                                aria-label="enhanced table">

                                <TableHead>
                                    <TableRow>
                                        {headCells.map((headCell) => (
                                            <TableCell
                                                key={headCell.id}
                                                className={classes.tableHeading}
                                                align={headCell.numeric ? 'right' : 'left'}
                                                padding={headCell.disablePadding ? 'none' : 'default'}
                                                sortDirection={orderBy === headCell.id ? 'asc' : false}>
                                                <TableSortLabel
                                                    active={orderBy === headCell.id}
                                                    direction={orderBy === headCell.id ? (order === 'asc' ? 'asc' : 'desc') : undefined}
                                                    onClick={(e => createSortHandler(e, headCell.id))}>
                                                    {headCell.label}
                                                </TableSortLabel>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {customerList.length > 0 ?
                                        customerList.map((row, index) => {
                                            return (
                                                <TableRow
                                                    className={classes.tableRow}
                                                    hover
                                                    onClick={(event) => onEditClick(event, row.customerId)}
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={row.customerId}>
                                                    <TableCell component="th" scope="row" padding="default">
                                                        {row.name}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                        :
                                        <TableRow>
                                            <TableCell align="center" colSpan={5}>No data available</TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={recordCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </div>
            <div style={{ marginTop: 5, marginBottom: 20, }}>
                {loading ? <CreateLoadingLine /> : null}
            </div>
        </div >


    )
}

export default React.memo(ViewCustomersWidget);